import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../utils/utils';
import { deleteOrder, editOrder, getOrders } from '../../../../crud/orders.crud';
import { IEditOrder, IOrderResponse } from '../../../../interfaces/order';

type OrderData = {
  page: number;
  perPage: number;
  statuses: string;
  userId?: number;
  driverId?: number;
  accord_order_state?: string;
  payment_status?: string;
  company_id?: string;
  date_from?: string;
  date_to?: string;
  hide_delivery_cost?: boolean;
  csv?: boolean;
  user_phone?: string | null;
  user_email?: string | null;
  user_name?: string | null;
  stock_status?: string;
  id?: number;
};

export const useGetOrders = (clearFiltersFind: () => void) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState<IOrderResponse[] | null>([]);
  const [page, setPage] = useState({ page: 1, total: 0 });
  const [editLoading, setEditLoading] = useState(false);
  const [editSuccess, setEditSuccess] = useState(false);
  const [perPage, setPerPage] = useState(
    localStorage.getItem('perPage') ? parseInt(localStorage.getItem('perPage')!, 10) : 20
  );
  const [firstItem, setFirstItem] = useState<IOrderResponse | undefined>(undefined);

  const fetch = async (data: OrderData) => {
    setLoading(true);
    getOrders({ ...data, per_page: data.perPage })
      .then((res: any) => {
        setOrders(res.data.data);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { page, total } = res.data;
        setPage({ page, total });
        if (page === 1 && !data.driverId && !data.userId && !data.id) {
          setFirstItem(res.data.data?.[0]);
        }
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateOrders = async (data: OrderData) => {
    getOrders({ ...data, per_page: data.perPage }).then((res: any) => {
      if (res.data.data?.[0]?.id !== firstItem?.id) {
        setFirstItem(res.data.data?.[0]);
        setOrders(res.data.data);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { page, total } = res.data;
        setPage({ page, total });
        clearFiltersFind();
      }
    });
  };

  const editStatus = async (id: number, data: IEditOrder) => {
    setEditLoading(true);
    editOrder(id, data)
      .then((res: any) => {
        setEditSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setEditLoading(false);
        setTimeout(() => {
          setEditSuccess(false);
        }, 200);
      });
  };

  const delOrder = async (id: number) => {
    setEditLoading(true);
    deleteOrder(id)
      .then((res: any) => {
        setEditSuccess(true);
      })
      .catch(e => {
        enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
          variant: 'error',
        });
      })
      .finally(() => {
        setEditLoading(false);
        setTimeout(() => {
          setEditSuccess(false);
        }, 200);
      });
  };

  return {
    fetch,
    loading,
    orders,
    page,
    setPerPage,
    perPage,
    updateOrders,
    editLoading,
    editStatus,
    editSuccess,
    delOrder,
  };
};
